module.exports = __webpack_public_path__ + "img/sb01.21177329.png";